import React from 'react';
import { motion } from 'framer-motion';
import { Hash, Receipt, Percent, BadgeDollarSign, HandCoins, Banknote } from 'lucide-react';
interface Metric {
  label: string;
  value: string;
  icon?: string;
}
interface MetricsBarProps {
  metrics: Metric[];
}
const iconMap: Record<string, React.ReactNode> = {
  hash: <Hash className="w-4 h-4" data-id="element-981" />,
  receipt: <Receipt className="w-4 h-4" data-id="element-982" />,
  percent: <Percent className="w-4 h-4" data-id="element-983" />,
  badge: <BadgeDollarSign className="w-4 h-4" data-id="element-984" />,
  hands: <HandCoins className="w-4 h-4" data-id="element-985" />,
  banknote: <Banknote className="w-5 h-5" data-id="element-986" />
};
const iconColors = [{
  bg: 'bg-blue-100 dark:bg-blue-900/30',
  text: 'text-blue-600 dark:text-blue-400'
}, {
  bg: 'bg-emerald-100 dark:bg-emerald-900/30',
  text: 'text-emerald-600 dark:text-emerald-400'
}, {
  bg: 'bg-violet-100 dark:bg-violet-900/30',
  text: 'text-violet-600 dark:text-violet-400'
}, {
  bg: 'bg-rose-100 dark:bg-rose-900/30',
  text: 'text-rose-600 dark:text-rose-400'
}, {
  bg: 'bg-teal-100 dark:bg-teal-900/30',
  text: 'text-teal-600 dark:text-teal-400'
}, {
  bg: 'bg-amber-100 dark:bg-amber-900/30',
  text: 'text-amber-600 dark:text-amber-400'
}];
export function MetricsBar({
  metrics
}: MetricsBarProps) {
  return <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 gap-3 mb-6" data-id="element-987">
      {metrics.map((metric, index) => {
      const icon = metric.icon ? iconMap[metric.icon] : null;
      const colorConfig = iconColors[index % iconColors.length];
      const isHighlight = metric.label === 'Total Facturado';
      return <motion.div key={index} initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.03,
        duration: 0.25,
        ease: 'easeOut'
      }} className={`
              relative overflow-hidden rounded-xl transition-all duration-200
              ${isHighlight ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 dark:from-gray-100 dark:via-white dark:to-gray-100 shadow-lg col-span-2 sm:col-span-1' : 'bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 hover:shadow-md'}
            `} data-id="element-988">
            {/* Shimmer overlay for highlight card */}
            {isHighlight && <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent pointer-events-none" data-id="element-989" />}

            <div className={`p-4 sm:p-5 ${isHighlight ? 'py-5 sm:py-6' : ''}`} data-id="element-990">
              <div className="flex items-center gap-3 mb-3" data-id="element-991">
                {icon && <div className={`
                      p-2 rounded-lg
                      ${isHighlight ? 'bg-white/10 text-white dark:bg-gray-900/20 dark:text-gray-900' : `${colorConfig.bg} ${colorConfig.text}`}
                    `} data-id="element-992">
                    {icon}
                  </div>}
                <p className={`
                    text-[11px] font-semibold uppercase tracking-wider
                    ${isHighlight ? 'text-gray-400 dark:text-gray-500' : 'text-gray-500 dark:text-gray-400'}
                  `} data-id="element-993">
                  {metric.label}
                </p>
              </div>
              <p className={`
                  text-xl font-bold font-mono tabular-nums tracking-tight truncate
                  ${isHighlight ? 'text-white dark:text-gray-900' : 'text-gray-900 dark:text-white'}
                `} data-id="element-994">
                {metric.value}
              </p>
            </div>
          </motion.div>;
    })}
    </div>;
}